import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import LeadsAssignedService from "../../services/LeadsAssignedService";
import $ from "jquery";
import "datatables.net";
import AuthService from "../../services/AuthService";
import RegisterUserService from "../../services/RegisterUserService";
import { MdRepeat } from "react-icons/md";
import { FaClipboardList, FaPlus } from "react-icons/fa";
import ToastService from "../../services/ToastService";
import LeadService from "../../services/LeadService";
import { getStatusName } from "../../constants/leadConstants";
import { printLeadReport } from "../../utils/printLeadReport";
const API_URL = process.env.REACT_APP_API_URL;
import "@fortawesome/fontawesome-free/css/all.min.css";

const unwrapJsonArray = (val) => {
  if (val == null) return [];
  if (Array.isArray(val)) return val;
  if (Array.isArray(val.$values)) return val.$values;
  return [];
};

const normalizeLead = (l) => {
  if (!l || typeof l !== "object") return l;
  return {
    id: l.id ?? l.Id,
    leadCode: l.leadCode ?? l.LeadCode,
    firstName: l.firstName ?? l.FirstName,
    lastName: l.lastName ?? l.LastName,
    email: l.email ?? l.Email,
    contactNumber: l.contactNumber ?? l.ContactNumber,
    source: l.source ?? l.Source,
    property: l.property ?? l.Property,
    address: l.address ?? l.Address,
  };
};

const normalizeUser = (u) => {
  if (!u || typeof u !== "object") return u;
  return {
    id: u.id ?? u.Id,
    firstName: u.firstName ?? u.FirstName,
    lastName: u.lastName ?? u.LastName,
    email: u.email ?? u.Email,
  };
};

const normalizeLeadStatus = (ls) => {
  if (!ls || typeof ls !== "object") return ls;
  return {
    id: ls.id ?? ls.Id,
    leadStatusName: ls.leadStatusName ?? ls.LeadStatusName,
  };
};

const normalizeLeadAssignedRow = (row) => {
  if (!row || typeof row !== "object") return row;
  const rawLead = row.lead ?? row.Lead;
  const rawUser = row.user ?? row.User;
  const rawStatus = row.leadStatus ?? row.LeadStatus;
  return {
    id: row.id ?? row.Id,
    leadId: row.leadId ?? row.LeadId,
    leadStatusId: row.leadStatusId ?? row.LeadStatusId,
    userId: row.userId ?? row.UserId,
    propertyTypeId: row.propertyTypeId ?? row.PropertyTypeId,
    conversationComment: row.conversationComment ?? row.ConversationComment,
    leadAssignedDate: row.leadAssignedDate ?? row.LeadAssignedDate,
    followUpDate: row.followUpDate ?? row.FollowUpDate,
    nextUpdate: row.nextUpdate ?? row.NextUpdate,
    agencyName: row.agencyName ?? row.AgencyName ?? "",
    lead: rawLead ? normalizeLead(rawLead) : null,
    user: rawUser ? normalizeUser(rawUser) : null,
    leadStatus: rawStatus ? normalizeLeadStatus(rawStatus) : null,
  };
};

const LA_PALETTE = [
  "linear-gradient(135deg,#6366f1,#4f46e5)",
  "linear-gradient(135deg,#06b6d4,#0891b2)",
  "linear-gradient(135deg,#22c55e,#15803d)",
  "linear-gradient(135deg,#f59e0b,#d97706)",
  "linear-gradient(135deg,#ec4899,#be185d)",
  "linear-gradient(135deg,#8b5cf6,#6d28d9)",
];
const escHtml = (s) =>
  String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
const digitsOnlyPhone = (s) => String(s ?? "").replace(/\D/g, "");
/** WhatsApp wa.me expects digits only (include country code in stored numbers). */
const whatsappHref = (raw) => {
  const d = digitsOnlyPhone(raw);
  return d.length >= 8 ? `https://wa.me/${d}` : "#";
};
const initLetter = (name = "") => (String(name).trim()[0] || "?").toUpperCase();
const pickColor = (seed = "") => {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return LA_PALETTE[h % LA_PALETTE.length];
};
const fmtDate = (raw) => {
  if (!raw) return "—";
  const d = new Date(raw);
  return isNaN(d.getTime()) ? "—" : d.toLocaleDateString();
};
const statusCssMap = {
  AssignedToEmployee:   "status-assigned",
  HotClient:            "status-hot",
  Interested:           "status-interested",
  NotInterested:        "status-notinterested",
  PhoneNotPicked:       "status-callback",
  InvalidNumber:        "status-invalid",
  ContactAfterSomeTime: "status-callback",
  CallBackLater:        "status-callback",
  UpcomingVisit:        "status-upcoming",
  Complete:             "status-complete",
  Visited:              "status-visited",
  DealDone:             "status-dealdone",
  PaymentPending:       "status-paymentpending",
  Closed:               "status-closed",
  NewImported:          "status-newimported",
};

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function LeadsAssigned() {
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [selectAll, setSelectAll] = useState(false);
  const [LeadsAssigned, setLeadsAssigned] = useState([]);
  const navigate = useNavigate();
  const toast = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const tableRef = useRef(null);
  const [employees, setselectedUser] = useState([]);
  const queryParam = useQuery();
  const [selectedValue, setSelectedValue] = useState("");
  const [UserId] = useState(() => AuthService.resolveScopedUserId(queryParam.get("id")));
  const userRole = AuthService.getLoggedInRoleId();
  const [isEmployeeSelectedError, setIsEmployeeSelectedError] = useState(false);
  const toastService = new ToastService(toast);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [leadStatus, setLeadStatus] = useState([]);
  const savedPageNumber = localStorage.getItem("currentPageNumber")
    ? parseInt(localStorage.getItem("currentPageNumber"))
    : 1;
  const [pageNumber, setPageNumber] = useState(savedPageNumber);
  const pageSize = 10;

  const ClientId = AuthService.getLoggedInClientId();
  const [agencyBranding, setAgencyBranding] = useState(null);
  const [recordsTotal, setRecordsTotal] = useState(0);
  const [recordsFiltered, setRecordsFiltered] = useState(0);

  const currentDate = new Date();
  const formattedCurrentDate = currentDate.toISOString().split("T")[0];
  const startOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1,
  );
  const formattedStartOfMonth = startOfMonth.toISOString().split("T")[0];
  const [startDate, setStartDate] = useState(formattedStartOfMonth);
  const [endDate, setEndDate] = useState(formattedCurrentDate);

  const startDateRef = useRef(formattedStartOfMonth);
  const endDateRef = useRef(formattedCurrentDate);
  const searchTermRef = useRef("");

  const tenDaysAgo = new Date();
  tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
  const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0];

  useEffect(() => {
    const fetchEmployee = async () => {
      try {
        const users = await RegisterUserService.getEmployessByRoleId(4);
        setselectedUser(users);
      } catch (error) {
        console.error("Error fetching users:", error);
        toastService.showError("Error", "Failed to fetch users data");
      }
    };

    const fetchLeadStatus = async () => {
      try {
        const leadstatus = await LeadService.getAllLeadStatus();
        setLeadStatus(leadstatus);
      } catch (error) {
        console.error("Error fetching lead status:", error);
      }
    };

    fetchLeadStatus();
    fetchEmployee();
  }, [UserId]);

  useEffect(() => {
    if (!ClientId) return;
    AuthService.getAgencyLogoAndNameByClientId(ClientId)
      .then((data) => setAgencyBranding(data))
      .catch((error) => console.error("Error fetching agency branding:", error));
  }, [ClientId]);

  useEffect(() => {
    if (Notification.permission === "default") {
      Notification.requestPermission();
    }
  }, []);

  const printLead = (leadassigned) => {
    printLeadReport(
      leadassigned,
      ClientId,
      AuthService.getAgencyLogoAndNameByClientId,
      agencyBranding,
    );
  };

  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);
    if (isChecked) {
      setSelectedRows(new Set(LeadsAssigned.map((lead) => lead.leadId)));
    } else {
      setSelectedRows(new Set());
    }
  };

  const handleChange = (event) => {
    setSelectedValue(event);
    if (event) {
      setIsEmployeeSelectedError(false);
    }
  };

  const ReAssignLead = async () => {
    if (!selectedValue) {
      toastService.showWarning(
        "Warning",
        "Please select an employee to re-assign the lead",
      );
      return;
    }
    if (selectedRows.length === 0) {
      toastService.showWarning(
        "Warning",
        "Please select at least one lead to re-assign",
      );
      return;
    }

    try {
      await LeadsAssignedService.ReAssignedLeads(
        selectedValue,
        Array.from(selectedRows),
      );
      toastService.showSuccess("Success", "Lead Re-Assigned successfully");
      setSelectedValue("");
      setSelectedRows(new Set());
      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        const table = $(tableRef.current).DataTable();
        table.ajax.reload(null, false); // This will reload the data and preserve the current page (false means do not reset to page 1)
      }
    } catch (error) {
      toastService.showError("Error", "Failed to Assign lead");
    }
  };

  function getStatusClass(leadStatusName) {
    switch (leadStatusName) {
      case "AssignedToEmployee":
        return "badge badge-sm bg-gradient-success";
      case "Interested":
        return "badge badge-sm bg-gradient-success";
      case "HotClient":
        return "badge badge-sm bg-gradient-danger";
      case "NotInterested":
        return "badge badge-sm bg-gradient-secondary";
      case "CallBackLater":
        return "badge badge-sm bg-gradient-dark";
      case "InvalidNumber":
        return "badge badge-sm bg-gradient-light";
      case "Complete":
        return "badge badge-sm bg-gradient-secondary";
      case "Visited":
        return "badge badge-sm bg-gradient-primary";
      case "Upcoming Visit":
        return "badge badge-sm bg-gradient-warning";
      default:
        return "";
    }
  }


  const canManage = parseInt(userRole, 10) !== 4;

  // const handleCheckboxChange = (leadId) => {
  //   const updatedSelectedRows = Array.from(selectedRows);
  //   if (updatedSelectedRows.includes(leadId)) {
  //     setSelectedRows(updatedSelectedRows.filter(id => id !== leadId));
  //   } else {
  //     setSelectedRows([...updatedSelectedRows, leadId]);
  //   }
  // };

  const handleCheckboxChange = (leadId) => {
    const updatedSelectedRows = new Set(selectedRows);
    if (updatedSelectedRows.has(leadId)) {
      updatedSelectedRows.delete(leadId);
    } else {
      updatedSelectedRows.add(leadId);
    }
    setSelectedRows(updatedSelectedRows);
  };

  useEffect(() => {
    startDateRef.current = startDate;
  }, [startDate]);

  useEffect(() => {
    endDateRef.current = endDate;
  }, [endDate]);

  useEffect(() => {
    searchTermRef.current = searchTerm;
  }, [searchTerm]);

  const reloadAssignedTable = () => {
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().ajax.reload();
    }
  };

  const buildAssignedQueryParams = (data, withSelectColumn) => {
    const params = new URLSearchParams();
    const search = searchTermRef.current?.trim();
    if (search) params.set("searchTerm", search);
    if (startDateRef.current) params.set("fromDate", startDateRef.current);
    if (endDateRef.current) params.set("toDate", endDateRef.current);

    const sortKeys = withSelectColumn
      ? [null, "leadCode", "firstName", null, null, null, null, "leadAssignedDate", null, "followUpDate", "nextUpdate", null]
      : ["leadCode", "firstName", null, null, null, null, "leadAssignedDate", null, "followUpDate", "nextUpdate", null];

    const orderCol = data.order?.[0]?.column;
    const orderDir = data.order?.[0]?.dir;
    const sortColumn =
      orderCol != null && sortKeys[orderCol] ? sortKeys[orderCol] : "";
    if (sortColumn) params.set("sortColumn", sortColumn);
    if (orderDir) params.set("sortDirection", orderDir);

    const qs = params.toString();
    return qs ? `?${qs}` : "";
  };

  useEffect(() => {
    const token = AuthService.getToken();

    const selectColumn = {
      data: "leadId",
      name: "Select",
      render: function (data, type, row) {
        const isChecked = selectedRows.has(row.leadId);
        const isDisabled = row.isLeadAssigned;
        return `<input type="checkbox" class="row-checkbox" data-row="${
          row.leadId
        }" ${isDisabled ? "disabled" : ""} ${isChecked ? "checked" : ""} /> `;
      },
      orderable: false,
      searchable: false,
    };

    const dataColumns = [
        {
          data: null,
          name: "Lead Code",
          autoWidth: true,
          render: function (data, type, row) {
            const code = row.lead ? row.lead.leadCode : "—";
            return `<span class="lead-code-pill">${escHtml(code)}</span>`;
          },
        },
        {
          data: null,
          name: "First Name",
          autoWidth: true,
          render: function (data, type, row) {
            const name = row.lead ? row.lead.firstName : "Unknown";
            const seed = `${row.lead?.firstName || ""}${row.lead?.email || ""}`;
            return `
              <div class="user-cell">
                <span class="user-avatar" style="background:${pickColor(seed)}">${escHtml(initLetter(name))}</span>
                <span class="user-cell-meta"><span class="user-cell-name">${escHtml(name)}</span></span>
              </div>`;
          },
        },
        {
          data: null,
          name: "Contact",
          orderable: false,
          autoWidth: true,
          render: function (data, type, row) {
            const phone = row.lead?.contactNumber;
            if (!phone) return `<span class="cell-muted">—</span>`;
            const safeShow = escHtml(phone);
            const telSafe = escHtml(String(phone).trim());
            const wa = whatsappHref(phone);
            const waDisabled = wa === "#";
            return `
              <div class="la-ivr-contact" title="${safeShow}">
                <a href="tel:${telSafe}" class="la-ivr-btn la-ivr-call" aria-label="Call ${safeShow}" title="Call"><i class="fas fa-phone"></i></a>
                <a href="${waDisabled ? "#" : wa}" ${waDisabled ? "" : 'target="_blank" rel="noopener noreferrer"'} class="la-ivr-btn la-ivr-wa ${waDisabled ? "la-ivr-wa-disabled" : ""}" aria-label="WhatsApp ${safeShow}" title="WhatsApp"><i class="fab fa-whatsapp"></i></a>
              </div>`;
          },
        },
        {
          data: null,
          name: "Source",
          autoWidth: true,
          render: function (data, type, row) {
            const src = (row.lead?.source || "").toLowerCase();
            if (src === "fb")
              return `<span class="source-chip fb" title="Facebook"><i class="fab fa-facebook-f"></i></span>`;
            if (src === "ig")
              return `<span class="source-chip ig" title="Instagram"><i class="fab fa-instagram"></i></span>`;
            return `<span class="cell-muted">—</span>`;
          },
        },
        {
          data: null,
          name: "Lead Status",
          autoWidth: true,
          render: function (data, type, row) {
            const status = getStatusName(row.leadStatusId);
            const cls = statusCssMap[status] || "status-default";
            return `<span class="lead-status ${cls}">${escHtml(status)}</span>`;
          },
        },
        {
          data: null,
          name: "Property",
          autoWidth: true,
          render: function (data, type, row) {
            const prop = row.lead?.property;
            if (!prop) return `<span class="cell-muted">—</span>`;
            const safe = escHtml(prop);
            return `<span class="property-pill" title="${safe}">${safe}</span>`;
          },
        },
        {
          data: "leadAssignedDate",
          name: "LeadAssigned Date",
          autoWidth: true,
          render: function (data) {
            return `<span class="date-chip">${escHtml(fmtDate(data))}</span>`;
          },
        },
        {
          data: null,
          name: "Employee Name",
          autoWidth: true,
          render: function (data, type, row) {
            const emp = row.user;
            if (!emp) return `<span class="cell-muted">—</span>`;
            const fullName =
              `${emp.firstName || ""} ${emp.lastName || ""}`.trim() ||
              "Employee";
            const seed = `${emp.firstName || ""}${emp.lastName || ""}${emp.email || ""}`;
            return `
              <div class="emp-cell">
                <span class="emp-avatar" style="background:${pickColor(seed)}">${escHtml(initLetter(emp.firstName))}</span>
                <span class="emp-name">${escHtml(fullName)}</span>
              </div>`;
          },
        },
        {
          data: "followUpDate",
          name: "followUpDate",
          autoWidth: true,
          render: function (data) {
            return `<span class="date-chip">${escHtml(fmtDate(data))}</span>`;
          },
        },
        {
          data: "nextUpdate",
          name: "Next Update",
          autoWidth: true,
          render: function (data) {
            return `<span class="date-chip">${escHtml(fmtDate(data))}</span>`;
          },
        },
        {
          data: null,
          orderable: false,
          searchable: false,
          render: function (data, type, row) {
            const isAuthorized = parseInt(userRole, 10) !== 4;
            let actions = `<button class="action-btn edit-lead-btn" data-id="${row.id}" title="Edit"><i class="pi pi-pencil"></i></button>`;
            if (isAuthorized) {
              actions += `<button class="action-btn print-lead-btn" data-id="${row.id}" title="Print"><i class="fas fa-print"></i></button>`;
            }
            return actions;
          },
        },
    ];

    const table = $(tableRef.current).DataTable({
      processing: true,
      serverSide: true,
      searching: false,
      layout: {
        topStart: "pageLength",
        topEnd: null,
        bottomStart: "info",
        bottomEnd: "paging",
      },
      order: [[canManage ? 7 : 6, "desc"]],
      displayStart: (savedPageNumber - 1) * pageSize,
      ajax: function (data, callback, settings) {
        const currentPage = Math.floor(data.start / data.length) + 1;
        localStorage.setItem("currentPageNumber", currentPage);
        setPageNumber(currentPage);
        const url = `${API_URL}/LeadAssigned/GetAllLeadAssignedByUserId/${UserId}/${ClientId}/${currentPage}/${pageSize}${buildAssignedQueryParams(data, canManage)}`;

        $.ajax({
          url,
          type: "POST",
          dataType: "json",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          success: function (response) {
            const envelope = response.value ?? response;
            const rawPayload = envelope.data ?? envelope.Data;
            const dataArr = unwrapJsonArray(rawPayload).map(normalizeLeadAssignedRow);
            callback({
              draw: parseInt(data.draw, 10),
              recordsTotal: envelope.recordsTotal ?? envelope.RecordsTotal ?? 0,
              recordsFiltered: envelope.recordsFiltered ?? envelope.RecordsFiltered ?? 0,
              data: dataArr,
            });
          },
          error: function (xhr, error, code) {
            console.error("API Request failed:", error, xhr);
            toastService.showError("Error", "Failed to fetch leads data");
          },
        });
      },
      columnDefs: canManage ? [{ targets: [0], visible: true, searchable: false }] : [],
      columns: canManage ? [selectColumn, ...dataColumns] : dataColumns,
      drawCallback: function (settings) {
        $(tableRef.current)
          .find(".row-checkbox")
          .each(function () {
            const leadId = $(this).data("row");
            const rowData = settings.aoData.find(
              (row) => row._aData.leadId === leadId,
            );
            if (rowData) {
              const isDisabled = rowData._aData.isLeadAssigned;
              $(this).prop("disabled", isDisabled);
              $(this).prop("checked", selectedRows.has(leadId));
            }
          });
      },
      stateSave: true,
    });
    $(tableRef.current).on("click", ".print-lead-btn", function () {
      const leadId = $(this).data("id");
      const leadassigned = table.row($(this).closest("tr")).data();
      printLead(leadassigned); // Call the printLead function with the leadassigned data
    });
    $(tableRef.current).on("click", ".edit-lead-btn", function () {
      const leadId = $(this).data("id");
      navigate(`/editleadassigned/${leadId}`);
    });
    $(tableRef.current).on("change", ".row-checkbox", function () {
      const leadId = $(this).data("row"); // matches data-row attribute in column render
      setSelectedRows((prev) => {
        const next = new Set(prev);
        if ($(this).is(":checked")) {
          next.add(leadId);
        } else {
          next.delete(leadId);
        }
        return next;
      });
    });
    return () => {
      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
    };
  }, [UserId, ClientId, canManage]);

  const btnStyle = {
    background: 'linear-gradient(135deg, #344767 0%, #21243d 100%)',
    border: 'none', borderRadius: '9px', padding: '9px 18px',
    color: '#fff', fontWeight: '600', fontSize: '13px', cursor: 'pointer',
    display: 'inline-flex', alignItems: 'center', gap: '7px',
    boxShadow: '0 4px 12px rgba(52,71,103,0.25)', whiteSpace: 'nowrap',
    transition: 'opacity 0.2s, transform 0.2s',
  };
  const selectStyle = {
    padding: '9px 14px',
    border: `1.5px solid ${isEmployeeSelectedError ? '#f5365c' : '#e9ecef'}`,
    borderRadius: '9px', fontSize: '13px', color: '#344767',
    background: '#fff', outline: 'none', minWidth: '220px', cursor: 'pointer',
  };
  const filterLbl = {
    fontSize: '10px', fontWeight: '700', color: '#8392ab',
    textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '3px',
    lineHeight: 1,
  };
  const filterInp = {
    padding: '6px 8px', border: '1.5px solid #e9ecef', borderRadius: '8px',
    fontSize: '12px', color: '#344767', background: '#fff', outline: 'none',
    height: '32px', boxSizing: 'border-box',
  };
  const filterBtnStyle = {
    ...btnStyle,
    padding: '6px 12px',
    fontSize: '12px',
    height: '32px',
  };

  const handleDateChange = (event) => {
    const value = event.target.value;
    const today = formattedCurrentDate;

    if (value === "today") {
      setStartDate(today);
      setEndDate(today);
    } else if (value === "yesterday") {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      const formattedYesterday = yesterday.toISOString().split("T")[0];
      setStartDate(formattedYesterday);
      setEndDate(formattedYesterday);
    } else if (value === "last10days") {
      setStartDate(formattedTenDaysAgo);
      setEndDate(today);
    } else if (value === "thisMonth") {
      setStartDate(formattedStartOfMonth);
      setEndDate(today);
    }
  };

  const handleApplyFilters = () => {
    reloadAssignedTable();
  };

  const handleSearchKeyDown = (event) => {
    if (event.key === "Enter") {
      handleApplyFilters();
    }
  };

  return (
    <div>
      <Toast ref={toast} />
      <style>{`
.la-toolbar-btn:hover{opacity:.85;transform:translateY(-1px)}
.la-ivr-contact{display:flex;align-items:center;gap:10px;flex-wrap:wrap;justify-content:center}
.la-ivr-btn{display:inline-flex;align-items:center;justify-content:center;width:36px;height:36px;border-radius:50%;
text-decoration:none!important;color:#fff!important;font-size:15px;
box-shadow:0 2px 10px rgba(0,0,0,.12);transition:transform .15s,box-shadow .15s}
.la-ivr-btn:hover{color:#fff!important;transform:scale(1.06)}
.la-ivr-call{background:linear-gradient(145deg,#5e72e4,#324cdd)}
.la-ivr-wa{background:linear-gradient(145deg,#25d366,#128c7e)}
.la-ivr-wa-disabled{opacity:.35;pointer-events:none;cursor:not-allowed}
`}</style>

      {canManage && (
        <div style={{
          display: 'flex', alignItems: 'center', flexWrap: 'wrap',
          gap: '10px', marginBottom: '16px',
          background: '#fff', borderRadius: '14px',
          padding: '14px 18px',
          boxShadow: '0 2px 12px rgba(52,71,103,0.07)',
        }}>
          {/* Left group: employee select + re-assign */}
          <select
            name="userId"
            id="userId"
            style={selectStyle}
            value={selectedValue}
            onChange={(e) => handleChange(e.target.value)}
          >
            <option value="" disabled>Re-Assign lead(s) to employee…</option>
            {employees.map((employee) => (
              <option key={employee.id} value={employee.id}>
                {employee.firstName}
              </option>
            ))}
          </select>

          <button
            type="button"
            className="la-toolbar-btn"
            style={btnStyle}
            onClick={() => ReAssignLead()}
          >
            <MdRepeat size={14} /> Re-Assign Leads
          </button>

          {isEmployeeSelectedError && (
            <span style={{ fontSize: '12px', color: '#f5365c', display: 'flex', alignItems: 'center', gap: '4px' }}>
              <i className="fas fa-exclamation-circle" /> Select an employee
            </span>
          )}

          {selectedRows.size > 0 && (
            <span style={{
              background: '#e8f5e9', color: '#2dce89', borderRadius: '20px',
              padding: '4px 12px', fontSize: '12px', fontWeight: '700',
            }}>
              {selectedRows.size} selected
            </span>
          )}

          {/* Spacer */}
          <div style={{ flex: 1 }} />

          {/* Right group: add */}
          <button
            type="button"
            className="la-toolbar-btn"
            style={btnStyle}
            onClick={() => navigate('/addleadsassigned')}
          >
            <FaPlus size={12} /> Add Leads
          </button>
        </div>
      )}

      <div className="col-12">
        <div className="list-card my-2">
          <div className="list-card-header" style={{ alignItems: 'flex-end', gap: '10px' }}>
            <div className="list-card-title">
              <span className="list-card-icon">
                <FaClipboardList />
              </span>
              <div>
                <h5>Assigned Leads</h5>
                <p>Track leads assigned to your team members</p>
              </div>
            </div>

            <div style={{
              display: 'flex', alignItems: 'flex-end', flexWrap: 'wrap',
              gap: '8px', marginLeft: 'auto', justifyContent: 'flex-end',
            }}>
              <div style={{ display: 'flex', flexDirection: 'column', minWidth: '118px' }}>
                <span style={filterLbl}>Quick Range</span>
                <select
                  className="db-sel"
                  style={{ ...filterInp, minWidth: '118px', width: '118px', cursor: 'pointer', paddingRight: '22px' }}
                  onChange={handleDateChange}
                  defaultValue="thisMonth"
                >
                  <option value="">Select Range</option>
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="last10days">Last 10 Days</option>
                  <option value="thisMonth">This Month</option>
                </select>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', minWidth: '128px' }}>
                <span style={filterLbl}>From</span>
                <input
                  className="db-inp"
                  type="date"
                  style={{ ...filterInp, width: '128px' }}
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', minWidth: '128px' }}>
                <span style={filterLbl}>To</span>
                <input
                  className="db-inp"
                  type="date"
                  style={{ ...filterInp, width: '128px' }}
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', width: '160px' }}>
                <span style={filterLbl}>Search</span>
                <div style={{ position: 'relative' }}>
                  <i
                    className="fas fa-search"
                    style={{
                      position: 'absolute', left: '9px', top: '50%',
                      transform: 'translateY(-50%)', color: '#8392ab', fontSize: '11px',
                    }}
                  />
                  <input
                    type="text"
                    placeholder="Search…"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onKeyDown={handleSearchKeyDown}
                    style={{ ...filterInp, width: '100%', paddingLeft: '28px' }}
                  />
                </div>
              </div>
              <button
                type="button"
                className="la-toolbar-btn"
                onClick={handleApplyFilters}
                style={filterBtnStyle}
              >
                <i className="fas fa-search" /> Search
              </button>
              {selectedRows.size > 0 && (
                <span className="list-count-pill" style={{ alignSelf: 'flex-end', marginBottom: '4px' }}>
                  {selectedRows.size} selected
                </span>
              )}
            </div>
          </div>
          <div className="card-body px-0 pb-2 pt-0">
            <div className="table-responsive p-0">
              <table
                className="table align-items-center mb-0"
                id="laAssignedLeadsTable"
                ref={tableRef}
              >
                <thead>
                  <tr>
                    {canManage && <th>Select</th>}
                    <th>Lead Code</th>
                    <th>Name</th>
                    <th className="text-center">Contact</th>
                    <th className="text-center">Source</th>
                    <th>Status</th>
                    <th>Property</th>
                    <th>Assigned</th>
                    <th>Employee</th>
                    <th>Follow Up</th>
                    <th>Next</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LeadsAssigned;
